module.exports = __webpack_public_path__ + "static/media/chevronLeft.0d62a4a4.svg";